// Shared test constants for both WebUser and AppUser tests

export const PW_WEB_TEST_CONFIG = {
  expressForm: {
    paymentContainer: "pw-test-id-stripe-express-form-membership-element",
  },
  profileForm: {
    fieldsContainer: "pw-test-id-membership-profile-form",
    fields: {
      firstName: "pw-test-id-first-name",
      lastName: "pw-test-id-last-name",
      phoneNumber: "pw-test-id-phone-number",
      emailAddress: "pw-test-id-email-address",
      state: "pw-test-id-state",
    },
    // Direct access to form fields (for easier usage)
    firstName: "pw-test-id-first-name",
    lastName: "pw-test-id-last-name",
    phoneNumber: "pw-test-id-phone-number",
    email: "pw-test-id-email-address",
    state: "pw-test-id-state",
  },
  stripeForm: {
    paymentContainer: "pw-test-id-stripe-form-membership-element",
    cardNumber: "pw-test-id-stripe-card-number",
    expiryDate: "pw-test-id-stripe-expiry-date",
    cvc: "pw-test-id-stripe-cvc",
    nameOnCard: "pw-test-id-stripe-name-on-card",
  },
  giveaway: {
    bannerContainer: "pw-test-id-membership-giveaway-banner-container",
  },
  membershipSelected: {
    selectedSubscriptionContainer: "pw-test-id-membership-selected-container",
  },
  customLocator: {
    stripeForm: {
      cardNumber: 'input[name="number"]',
      cardExpiry: 'input[name="expiry"]',
      cardCvc: 'input[name="cvc"]',
    },
  },
  actionBtns: {
    submitBtn: "pw-test-id-submit-btn",
    continueBtn: "pw-test-id-continue-btn",
  },
  successPage: {
    downloadAppBtn: "pw-test-id-download-app-btn",
  },
  successContainer: "pw-test-id-success-membership-container",
  /** VWO / E2E root targets. Both variants may mount; visibility is CSS-controlled (see WebSignUp plain layout). */
  orderSummaryPlain: {
    containerV1: "wl-order-summary-plain-v1",
    containerV2: "wl-order-summary-plain-v2",
  },
};

export const PW_ONE_OFF_FORM_READINESS_TEST_ID_CONFIG = {
  expressForm: {
    paymentContainer: "pw-test-id-stripe-express-form-one-off-element",
  },
  profileForm: {
    fieldsContainer: "pw-test-id-one-off-profile-form",
    fields: {
      firstName: "pw-test-id-first-name",
      lastName: "pw-test-id-last-name",
      phoneNumber: "pw-test-id-phone-number",
      emailAddress: "pw-test-id-email-address",
      state: "pw-test-id-state",
    },
  },
  stripeForm: {
    paymentContainer: "pw-test-id-stripe-form-one-off-element",
  },
  giveaway: {
    bannerContainer: "pw-test-id-one-off-giveaway-banner-container",
  },
  oneOffSelected: {
    selectedSubscriptionContainer: "pw-test-id-one-off-selected-container",
  },
  customLocator: {
    stripeForm: {
      cardNumber: 'input[name="number"]',
      cardExpiry: 'input[name="expiry"]',
      cardCvc: 'input[name="cvc"]',
    },
  },
  actionBtns: {
    submitBtn: "pw-test-id-submit-btn",
  },
  successContainer: "pw-test-id-success-one-off-container",
};

export const PW_MOBILE_TEST_CONFIG = {
  signInButton: "pw-test-id-sign-in-button",
  firstLoginFlow: {
    emailInput: "pw-test-id-email-input",
    submitEmail: "pw-test-id-submit-email",
    otpInput: "pw-test-id-otp-input",
    submitOtp: "pw-test-id-submit-otp",
    firstNameInput: "pw-test-id-first-name-input",
    lastNameInput: "pw-test-id-last-name-input",
    suburbInput: "pw-test-id-suburb-input",
    dobInput: "pw-test-id-dob-input",
    dobModal: "pw-test-id-dob-modal",
    dobSubmit: "pw-test-id-dob-submit",
    walkthroughNext: "pw-test-id-walkthrough-next",
    walkthroughGetStarted: "pw-test-id-walkthrough-get-started",
    firstTimeLoginClaim: "pw-test-id-first-time-login-claim",
    joyRideSkip: "pw-test-id-joy-ride-skip",
    setPasswordSkip: "pw-test-id-set-password-skip",
    firstPowerUpSkip: "pw-test-id-first-power-up-skip",
    choosePlanHeading: "pw-test-id-choose-plan-heading",
    choosePlanFeaturedCard: "pw-test-id-choose-plan-featured-card",
    choosePlanCarousel: "pw-test-id-choose-plan-carousel",
  },
  powerUpCash: {
    goToPowerUps: "pw-test-id-go-to-power-ups",
    useCash: "pw-test-id-use-cash",
    selectedPowerUp: "pw-test-id-selected-power-up",
    confirmPurchase: "pw-test-id-confirm-purchase",
    successPurchaseBtn: "pw-test-id-success-purchase-btn",
  },
  powerUpPoints: {
    goToPowerUps: "pw-test-id-go-to-power-ups",
    usePoints: "pw-test-id-use-points",
    bronzePowerUp: "pw-test-id-bronze-power-up",
    confirmPurchase: "pw-test-id-confirm-purchase",
    successPurchaseBtn: "pw-test-id-success-purchase-btn",
  },
  cancelFlow: {
    openCancelSubscription: "pw-test-id-open-cancel-subscription",
    continueCancel: "pw-test-id-cancel-continue",
    loseEntries: "pw-test-id-cancel-lose-entries",
    dialogConfirmYes: "pw-test-id-cancel-dialog-yes",
    reasonTooPricey: "pw-test-id-cancel-reason-too-pricey",
    openConfirmationModal: "pw-test-id-cancel-open-confirmation",
    entriesConfirmInput: "pw-test-id-cancel-entries-input",
    submitCancelAccount: "pw-test-id-cancel-submit-account",
    featuredCard: "pw-test-id-subscription-featured-card",
    carousel: "pw-test-id-subscription-carousel",
  },
  homeShopCarousel: {
    section: "pw-test-id-shop-home-carousel",
    seeMore: "pw-test-id-shop-home-see-more",
  },
  winnersShop: {
    introTakeMeToShop: "pw-test-id-shop-intro-take-me-to-shop",
    introDontShowAgain: "pw-test-id-shop-intro-dont-show-again",
    productCard: "pw-test-id-shop-product-card",
    featuredProductCard: "pw-test-id-shop-featured-product-card",
    soldOutStamp: "pw-test-id-shop-product-sold-out-stamp",
    addToCart: "pw-test-id-shop-add-to-cart",
    optionGroup: "pw-test-id-shop-option-group",
    optionValue: "pw-test-id-shop-option-value",
    bundleDrawerPrimary: "pw-test-id-shop-bundle-drawer-primary",
    lockItIn: "pw-test-id-shop-lock-it-in",
    payNow: "pw-test-id-shop-pay-now",
    checkoutBreakdown: "pw-test-id-shop-checkout-total-breakdown",
    checkoutTotalBeforeDiscount: "pw-test-id-shop-checkout-total-before-discount",
    checkoutUpsellDiscount: "pw-test-id-shop-checkout-upsell-discount",
    checkoutPromoDiscount: "pw-test-id-shop-checkout-promo-discount",
    checkoutTotalAmount: "pw-test-id-shop-checkout-total-amount",
    /** Shared by checkout Total breakdown and order-confirmation email HTML. */
    totalsLabels: {
      amountBeforeDiscount: "Amount before discount",
      boostDiscount: "Boost discount",
      membershipDiscount: "Membership discount",
      amountPayable: "Amount payable",
    },
    statusModalOk: "pw-test-id-shop-status-modal-ok",
    orderSuccessModal: "pw-test-id-shop-order-success-modal",
    orderSuccessClose: "pw-test-id-shop-order-success-close",
    pdpHero: "pw-test-id-shop-pdp-hero",
  },
  locker: {
    openLocker: "pw-test-id-open-locker",
    streak: "pw-test-id-locker-streak",
    claim: "pw-test-id-locker-claim",
    unlockIntroOk: "pw-test-id-unlock-intro-ok",
    lostStreakOk: "pw-test-id-lost-streak-ok",
  },
  discounts: {
    card: "pw-test-id-discount-card",
    cardOfferTitle: "pw-test-id-discount-card-offer-title",
    cardBusinessName: "pw-test-id-discount-card-business-name",
    details: "pw-test-id-discount-details",
    code: "pw-test-id-discount-code",
    primaryCta: "pw-test-id-discount-primary-cta",
    totalSavingsCard: "pw-test-id-total-savings-card",
    totalSavingsAmount: "pw-test-id-total-savings-amount",
    featuredStrip: "pw-test-id-featured-discount",
    trendingRow: "pw-test-id-trending-discounts",
    trendingBadge: "pw-test-id-trending-badge",
    listFilter: "pw-test-id-discounts-list-filter",
    listFilterAll: "pw-test-id-discounts-filter-all",
    listFilterEntryback: "pw-test-id-discounts-filter-entryback",
    categoryList: "pw-test-id-discount-categories",
    catalog: "pw-test-id-discounts-catalog",
    savingsLeaderboardFab: "pw-test-id-savings-leaderboard-fab",
    savingsLeaderboard: "pw-test-id-savings-leaderboard",
    savingsSeriesList: "pw-test-id-savings-series-list",
    savingsSeriesListRefresh: "pw-test-id-savings-series-list-refresh",
    savingsSeriesListActiveRow: "pw-test-id-savings-series-list-active-row",
    savingsSeriesListInactiveRow: "pw-test-id-savings-series-list-inactive-row",
    savingsSeriesListGameActiveRow:
      "pw-test-id-savings-series-list-game-active-row",
    savingsSeriesListGameInactiveRow:
      "pw-test-id-savings-series-list-game-inactive-row",
    savingsLeaderboardPreviousSeasonsTrigger:
      "pw-test-id-savings-leaderboard-previous-seasons-trigger",
    savingsLeaderboardPreviousSeasonsMenu:
      "pw-test-id-savings-leaderboard-previous-seasons-menu",
    savingsLeaderboardPodium: "pw-test-id-savings-leaderboard-podium",
  },
  winnersLadder: {
    dashboardViewLeaderboardsCta: "pw-test-id-winners-ladder-dashboard-cta",
    pastSeasonNavTutorial: "pw-test-id-past-season-nav-tutorial",
    seasonHistoryTrigger: "pw-test-id-winners-ladder-season-history-trigger",
    seasonHistorySheet: "pw-test-id-winners-ladder-season-history-sheet",
    gamesLeaderboardTable: "pw-test-id-games-winners-ladder",
  },
  pageScan: {
    routeSkeleton: "pw-test-id-route-skeleton",
    shopRouteSkeleton: "pw-test-id-shop-route-skeleton",
    headerLogo: "pw-test-id-page-scan-header-logo",
    headerCalendar: "pw-test-id-page-scan-header-calendar",
    headerAccount: "pw-test-id-page-scan-header-account",
    gamesFab: "pw-test-id-page-scan-games-fab",
    gamesHome: "pw-test-id-page-scan-games-home",
    giveawaysCurrent: "pw-test-id-page-scan-giveaways-current",
    giveawaysUpcoming: "pw-test-id-page-scan-giveaways-upcoming",
    giveawaysPast: "pw-test-id-page-scan-giveaways-past",
    settingsRefer: "pw-test-id-page-scan-settings-refer",
    shopCart: "pw-test-id-page-scan-shop-cart",
  },
  adminGates: {
    shopActivatedToggle: "pw-test-id-admin-shop-activated-toggle",
    shopDeactivateConfirm: "pw-test-id-admin-shop-deactivate-confirm",
    gamesEnabledToggle: "pw-test-id-admin-games-enabled-toggle",
    gamesDisableConfirm: "pw-test-id-admin-games-disable-confirm",
  },
};
